import RichTextEditorSkeleton from '../../../../../../components/RichText/Editor/skeleton';

export interface UnpublishedQuestionDescriptionSkeletonProps {
  className?: string;
}

const UnpublishedQuestionDescriptionSkeleton = ({ className }: UnpublishedQuestionDescriptionSkeletonProps) => {
  return <RichTextEditorSkeleton className={className} canUploadAttachment />;
};

export default UnpublishedQuestionDescriptionSkeleton;
